<template>
<div class="">
  <!-- <div class="head">

  </div> -->
  <div>
    <v-img
      src="/images/火腿/Front_logo.jpg"
      height="800"
    ></v-img>
  </div>
  <div class="content">
    <b-container>
      <div class="Block">
        <p>
          每个故事都有他的起源，来探访我们吧
        </p>
        <p>
          了解我们是如何打造世界独一无二的火腿品牌
        </p>
      </div>
      <div class="Block">
        <b-row>
          <b-col md="6">
            <v-img
              src="/images/火腿/CAVE.jpg"
            ></v-img>
          </b-col>
          <b-col md="6" style="display:flex;">
            <div style="margin:0 auto;">
              <p class="title titleSize">
                  J CINCO JOTAS的传奇精髓
              </p>
              <p style="margin-top:50px;">
                游览我们的地窖，深入了解1879年以来坚持传统的制作过程，整个过程历时五年以上。
              </p>
            </div>
          </b-col>
        </b-row>
      </div>
      <div class="Block">
        <b-row>
          <b-col md="6" style="display:flex;">
            <div style="margin:0 auto;">
              <p class="title titleSize">
                  精湛的手工艺
              </p>
              <p style="margin-top:50px;">
                5J CINCO JOTAS代代传承手工腌制工艺，从我们工匠大师学习每一片火腿是如何精心腌制的。
              </p>
            </div>
          </b-col>
          <b-col md="6">
            <v-img
              src="/images/火腿/22.jpg"
            ></v-img>
          </b-col>
        </b-row>
      </div>

      <div class="Block">
        <b-row>
          <b-col md="6">
            <v-img
              src="/images/火腿/TB2LYpNjiRnpuFjSZFCXXX2DXXa_!!479954274.jpg"
            ></v-img>
          </b-col>
          <b-col md="6" style="display:flex;">
            <div style="margin:0 auto;">
              <p class="title titleSize">
                  品尝盛宴
              </p>
              <p style="margin-top:50px;">
                品味享受西班牙的国宝，口中享受一份特别的味道，每一片火腿都是出自我们切割大师之手。
              </p>
            </div>
          </b-col>
        </b-row>
      <div class="divider">
        <p class="title titleSize">
            我们的产品
        </p>
      </div>
      <b-row>
        <b-col md="3" id="wrapper">
          <div id="elDiv">
            <v-img
              src="/images/火腿/new-product-image-1.jpg"
            ></v-img>
          </div>
          <p class="title titleSizeMini">
            橡果喂养100%伊比利亚火腿 后腿薄片
          </p>
          <p>
            70克薄片装
          </p>
        </b-col>
        <b-col md="3" id="wrapper">
          <div id="elDiv">
            <v-img
              src="/images/火腿/new-product-image-2.jpg"
            ></v-img>
          </div>
          <p class="title titleSizeMini">
            橡果喂养100%伊比利亚火腿 前腿薄片
          </p>
          <p>
            70克薄片装
          </p>
        </b-col>
        <b-col md="3" id="wrapper">
          <div id="elDiv">
            <v-img
              src="/images/火腿/new-product-image-3.jpg"
            ></v-img>
          </div>
          <p class="title titleSizeMini">
            橡果喂养100%伊比利亚火腿 后腿薄片
          </p>
          <p>
            40克薄片装
          </p>
        </b-col>
        <b-col md="3" id="wrapper">
          <div id="elDiv">
            <v-img
              src="/images/火腿/new-product-image-4.jpg"
            ></v-img>
          </div>
          <p class="title titleSizeMini">
            橡果喂养100%伊比利亚火腿 前腿薄片
          </p>
          <p>
            40克薄片装
          </p>
        </b-col>

        <b-col md="3" id="wrapper">
          <div id="elDiv">
            <v-img
              src="/images/火腿/new-product-image-5.jpg"
            ></v-img>
          </div>
          <p class="title titleSizeMini">
            橡果喂养100%伊比利亚火腿 后腿薄片
          </p>
          <p>
            40g*12整盒送礼礼盒
          </p>
        </b-col>
        <b-col md="3" id="wrapper">
          <div id="elDiv">
            <v-img
              src="/images/火腿/new-product-image-6.jpg"
            ></v-img>
          </div>
          <p class="title titleSizeMini">
            橡果喂养100%伊比利亚火腿 后腿薄片
          </p>
          <p>
            70g*12整盒送礼礼盒
          </p>
        </b-col>

        <b-col md="3" id="wrapper">
          <div id="elDiv">
            <v-img
              src="/images/火腿/new-product-image-14.jpg"
            ></v-img>
          </div>
          <p class="title titleSizeMini">
            橡果喂养100%伊比利亚火腿 前腿薄片
          </p>
          <p>
            40g*12整盒送礼礼盒
          </p>
        </b-col>
        <b-col md="3" id="wrapper">
          <div id="elDiv">
            <v-img
              src="/images/火腿/new-product-image-12.jpg"
            ></v-img>
          </div>
          <p class="title titleSizeMini">
            橡果喂养100%伊比利亚火腿 前腿薄片
          </p>
          <p>
            70g*12整盒送礼礼盒
          </p>
        </b-col>

        <b-col md="3" id="wrapper">
          <div id="elDiv">
            <v-img
              src="/images/火腿/new-product-image-9.jpg"
            ></v-img>
          </div>
          <p class="title titleSizeMini">
            5J CINCO JOTAS高级珠宝盒
          </p>
          <p>
            礼盒 新年送礼
          </p>
        </b-col>

        <b-col md="3" id="wrapper">
          <div id="elDiv">
            <v-img
              src="/images/火腿/_TUBE LOMO 500Gr.jpg"
            ></v-img>
          </div>
          <p class="title titleSizeMini">
            橡果喂养100%伊比利亚火腿 黑腿里脊
          </p>
          <p>
            400-600g
          </p>
        </b-col>

        <b-col md="3" id="wrapper">
          <div id="elDiv">
            <v-img
              src="/images/火腿/WechatIMG1395.jpeg"
            ></v-img>
          </div>
          <p class="title titleSizeMini">
            橡果喂养100%伊比利亚火腿 腌肩坝肉

          </p>
          <p>
            400-600g
          </p>
        </b-col>

        <b-col md="3" id="wrapper">
          <div id="elDiv">
            <v-img
              src="/images/火腿/WechatIMG1396.jpeg"
            ></v-img>
          </div>
          <p class="title titleSizeMini">
            橡果喂养100%伊比利亚火腿 腊肠
          </p>
          <p>
            400-600g
          </p>
        </b-col>
      </b-row>
      </div>
      <div class="divider">
        <p class="title titleSize">
            更多介绍
        </p>
      </div>
      <div class="Block">
        <b-row>
          <b-col md="6" style="display:flex;">
            <v-img
              src="/images/火腿/WechatIMG1399.png"
            ></v-img>
          </b-col>
          <b-col md="6">
            <v-img
              src="/images/火腿/WechatIMG1401.png"
            ></v-img>
          </b-col>
          <b-col md="6" style="display:flex;">
            <v-img
              src="/images/火腿/WechatIMG1400.png"
            ></v-img>
          </b-col>
          <b-col md="6">
            <v-img
              src="/images/火腿/WechatIMG1402.png"
            ></v-img>
          </b-col>
          <b-col md="6">
            <v-img
              src="/images/火腿/WechatIMG1403.jpeg"
            ></v-img>
          </b-col>
        </b-row>
      </div>


        <b-card
          style="margin-top:50px;"
          header="舌尖美食"
          header-tag="header">
          <b-card-text>
            <div id="scrollspy-nested" style="position:relative; height:500px; overflow-y:auto">
            <b-row>
              <b-col md="4" v-for="(item, index) in imgsG" :key="index">
                <b-card
                  class="mx-auto card_personel"
                  max-width="344"
                >
                  <v-img
                    :src="item"
                    height="200px"
                    @click="overlay = !overlay"
                  ></v-img>
                </b-card>
              </b-col>
            </b-row>
            </div>
          </b-card-text>
          <!-- <b-button href="#" variant="primary">了解更多</b-button> -->
        </b-card>
    </b-container>
  </div>

</div>
</template>

<script>

export default{
  name:"Huotui",
  components: {

  },
  metaInfo: {
      title: '燕参堂',
      // override the parent template and just use the above title only
      titleTemplate: '%s | 西班牙火腿',
      meta: [
        { name: 'description', content: '销售西班牙5J火腿/Cebo de campo' },
        { name: 'keywords', content: '西班牙火腿,5J火腿,Cebo de campo' },
      ]

  },
  data() {
    return {
      huotui:[],
      imgsG:[
        "/images/火腿/WechatIMG1407.jpeg",
        "/images/火腿/WechatIMG1410.jpeg",
        "/images/火腿/WechatIMG1411.jpeg",
        "/images/火腿/WechatIMG1412.jpeg",
        "/images/火腿/WechatIMG1406.jpeg",
        "/images/火腿/WechatIMG1405.jpeg",
        "/images/火腿/WechatIMG1409.jpeg",
        "/images/火腿/WechatIMG1413.jpeg",

      ],
    }
  },
  created() {

  }

}

</script>
<style scoped>
.head{
  height: 600px;
  width: 100%;
  /* background-color: red; */
  background-image: url("/images/火腿/head_bg.jpg");
  background-position: center;
  background-size: cover;
}

.content{
  background-color: #F2EDE3;
  overflow: hidden;
}

.stepper{
  position: sticky;
}

.fullSreen{
  margin: 0px;
  padding: 0px;
}

.text_block{
  border: 1px solid #FEFEEE;
  border-radius: 10px;
  padding: 10px;
  margin-top: 15px;
}

.Block{
  padding: 50px 0px 50px 0px;
  border-bottom: 1px black solid;
}

h1{
  font-family: "Cardo", serif;
  color: #A1907C;
}

p{
  color: #4A4A4A;
  font-family: "Cardo", serif;
  text-align: center;

}

.title{
  font-family: Raleway, 新宋体, NSimSun, 华文黑体, STHeiti, sans-serif;
  font-weight: bold;
  text-transform: uppercase;
  color: #b69f67;
}

.titleSize
{
  font-size: 30px;
}

.titleSizeMini
{
  font-size: 18px;
}

.divider{
  width: 100%;
  background: #000;
  min-height: 80px;
  padding: 20px 0px;
  margin-top: 80px;
}
#wrapper {
  position:relative;
  text-align: center;
}
#elDiv {
  width: 100%;
  display: inline-block;
}
.bg_pf_color2{
  /* background-color:rgb(45, 43, 53); */
  background-color:rgb(255, 245, 244);
}

.bg_pf_color{
  /* background-color:rgb(90, 86, 106); */

  background-color:rgba(238, 222, 223,1);
}
</style>
